import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { tx } from '@transifex/native';
import { TransifexVue } from '@transifex/vue2';

tx.init({
  token: '1/e538ea7442a61bec70aff8df56b4f5d685216391', // secret: 1/8a775882392050d7ccf22ab3afad27615120dcab
});

/*
Experience engine
Token: 1/4115046ce68867ec2942fa812834249b9505a6b9 Secret: 1/f045ddf21c10b3303bc28af89c8865bce022e3c1

*/



Vue.use(TransifexVue);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
